import { useAppConfig } from "../../../hooks/useAppConfig";
import { useIsMobile } from "../../MobileBreakpointContext";

const QuoteAppPreview = () => {
  const { data: appConfig } = useAppConfig();
  const isMobile = useIsMobile();

  if (isMobile) return null;

  return (
    <div style={{ position: "relative" }}>
      <img
        style={{
          width: "100%",
        }}
        src="https://topaesthetics.com/assets/img/img-export/1678457694-dr-humberto-palladino.jpg?auto=format,compress&w=1918"
      />
    </div>
  );
};

export default QuoteAppPreview;
